import React, { useEffect, useRef, useState } from "react";
import logo from "../../images/appLogoCrop.png";
import { AiOutlineExport } from "react-icons/ai";
import userIcon from "../../images/user.png";
import { RxHamburgerMenu } from "react-icons/rx";
import {
  AiOutlineSetting,
  AiOutlineSearch,
  AiOutlineMail,
  AiOutlineBell,
  AiOutlineClose,
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

// ─── All sidebar menu items (label + route) ───────────────────────────────────
const ALL_MENUS = [
  { label: "Home",                          path: "home" },
  // Employee
  { label: "Employee Registration",         path: "emp_reg" },
  { label: "Employee List",                 path: "emp_list" },
  { label: "Joining & Exit Report",         path: "empJoinExitReport" },
  { label: "Employee Status Report",        path: "empStatusReport" },
  { label: "Visa / Emirates ID Expiry",     path: "empVisaIDExpiryReport" },
  // Team
  { label: "Team Management",               path: "teamManagementDashboard" },
  // Leave
  { label: "Leave Allotment",               path: "leaveallotment" },
  { label: "Leave Application",             path: "leaveapplication" },
  { label: "Leave Approval",                path: "leaveapproval" },
  { label: "Leave Rejoin",                  path: "leaverejoin" },
  { label: "Leave Category",                path: "leavecat" },
  { label: "Leave Balance Report",          path: "leaveBalanceReport" },
  { label: "Leave Ledger",                  path: "leaveLedger" },
  { label: "Leave Requests & Approval",     path: "leaveRequestApprovalStatus" },
  { label: "Medical Leave Tracking",        path: "medicalLeaveTracking" },
  // Payroll
  { label: "Payroll",                       path: "payrollMain" },
  { label: "Payroll Add / Deduct",          path: "payroll" },
  { label: "WPS",                           path: "wps" },
  // Attendance
  { label: "Attendance Evaluation",         path: "atdcevaluation" },
  { label: "Timesheet",                     path: "timesheet" },
  { label: "Timesheet Summary Report",      path: "timesheetSummaryReport" },
  { label: "Attendance Punch Details",      path: "attendancePunchDetailsReport" },
  { label: "Absence Report",               path: "absenceReport" },
  { label: "Overtime Report",              path: "overtimeReport" },
  { label: "Late Coming / Early Leaving",  path: "lateEarlyReport" },
  // Reports & Events
  { label: "Reports",                       path: "reportsMenu" },
  { label: "Events / Calendar",             path: "bigCalendar" },
  // Settings
  { label: "Users",                         path: "users" },
  { label: "Holiday",                       path: "holiday" },
  // End of Service
  { label: "End of Service Application",    path: "endOfServiceApplication" },
  { label: "End of Service Approval",       path: "endOfServiceApproval" },
  // Fleet
  { label: "Fleet Information",             path: "fleetInformation" },
  { label: "Fleet List",                    path: "fleetList" },
  { label: "Fleet Insurance Expiry",        path: "fleetInsuranceExpiry" },
  { label: "Fleet Registration Expiry",     path: "fleetRegistrationExpiry" },
  // Document Management
  { label: "Document Management",           path: "documentManagement" },
  { label: "Document Expiry",               path: "documentExpiry" },
];

// ─── Highlight matched portion ────────────────────────────────────────────────
const HighlightMatch = ({ text, query }) => {
  if (!query) return <span>{text}</span>;
  const idx = text.toLowerCase().indexOf(query.toLowerCase());
  if (idx === -1) return <span>{text}</span>;
  return (
    <span>
      {text.slice(0, idx)}
      <span className="bg-yellow-200 text-gray-900 font-semibold rounded px-0.5">
        {text.slice(idx, idx + query.length)}
      </span>
      {text.slice(idx + query.length)}
    </span>
  );
};

const NavBar = ({ toggleShowSideBar }) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const storedLoginUser =
    JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];
  let user = null;
  let companyCode = null;
  let accessGroup = "";

  if (storedLoginUser) user = storedLoginUser[0]?.salesman_name?.trim();
  if (storedLoginUser) accessGroup = storedLoginUser[0]?.accessgrp?.trim();
  if (storedUserDataArray) companyCode = storedUserDataArray[0]?.cmpcode;

  const [allBranchData, setAllBranchData] = useState([]);
  const [branch, setBranch] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [accessGroupFromLocal, setAccessGroupFromLocal] = useState("");

  // ── Search state ────────────────────────────────────────────────────────────
  const [searchItem, setSearchItem] = useState("");
  const [filteredMenus, setFilteredMenus] = useState([]);
  const searchDropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  const navigate = useNavigate();

  // Filter menus as user types
  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearchItem(val);
    if (val.trim() === "") {
      setFilteredMenus([]);
    } else {
      setFilteredMenus(
        ALL_MENUS.filter((m) =>
          m.label.toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
  };

  const clearSearchItem = () => {
    setSearchItem("");
    setFilteredMenus([]);
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        searchDropdownRef.current &&
        !searchDropdownRef.current.contains(e.target) &&
        searchInputRef.current &&
        !searchInputRef.current.contains(e.target)
      ) {
        setFilteredMenus([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Branch fetch
  const fetchAllBranchData = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/MasterCount/${companyCode}/BRANCH/${user}/-`,
      );
      if (response.status === 200) setAllBranchData(response.data);
    } catch (error) {
      console.log("fetchAllBranchDataErr", error);
    }
  };

  useEffect(() => {
    const storedBranch = localStorage.getItem("BondTimeNavBranch");
    if (storedBranch) setSelectedBranch(storedBranch);
  }, []);

  useEffect(() => {
    if (user) fetchAllBranchData();
  }, [user]);

  const handleChange = (event) => {
    const val = event.target.value;
    setBranch(val);
    setSelectedBranch(val.trim());
    localStorage.setItem("BondTimeNavBranch", val.trim());
  };

  const onSignOut = () => navigate("/login");

  return (
    // <div className="w-full bg-[#F9FAFA]">
    <div className="w-full z-50">
      <div className="w-full flex relative">
        {/* Left — logo */}
        <div className="flex items-center p-2 cursor-pointer w-[42%] justify-start gap-3">
          <div className="md:hidden block" onClick={() => toggleShowSideBar()}>
            <RxHamburgerMenu />
          </div>
          <div className="w-[60%] flex justify-between">
            <img
              className="ml-4 mt-2 w-[190px] h-[90px] object-fit overflow-hidden"
              src={logo}
              alt=""
              onClick={() => navigate("/admin/home")}
            />
          </div>
        </div>

        {/* Right — search + branch + user + signout */}
        <div className="w-full flex justify-end items-center gap-18 relative">

          {/* ── Search ────────────────────────────────────────────── */}
          <div className="relative max-sm:w-full max-sm:mb-6">
            <input
              ref={searchInputRef}
              type="text"
              value={searchItem}
              onChange={handleSearchChange}
              placeholder="Search menu..."
              className="w-full py-2 pl-10 pr-4 rounded-lg bg-white text-black placeholder-gray-400 border border-gray-400 "
            />
            <div className="absolute left-3 top-1/2 -translate-y-1/2">
              <AiOutlineSearch className="text-gray-500" />
            </div>
            {searchItem && (
              <div
                className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                onClick={clearSearchItem}
              >
                <AiOutlineClose className="text-gray-500" />
              </div>
            )}

            {/* Dropdown results */}
            {filteredMenus.length > 0 && (
              <div
                ref={searchDropdownRef}
                className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-72 overflow-y-auto mt-1 min-w-[260px]"
              >
                {filteredMenus.map((menu, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      navigate(menu.path);
                      clearSearchItem();
                    }}
                    className="flex items-center justify-between px-4 py-2.5 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors"
                  >
                    <span className="text-sm text-gray-700">
                      <HighlightMatch text={menu.label} query={searchItem} />
                    </span>
                    {/* <span className="text-[10px] text-[#2663EB] bg-blue-50 border border-blue-200 px-2 py-0.5 rounded-full font-medium ml-3 whitespace-nowrap">
                      {menu.path}
                    </span> */}
                  </div>
                ))}

                {/* No results */}
                {filteredMenus.length === 0 && searchItem && (
                  <div className="px-4 py-3 text-sm text-gray-400 text-center">
                    No menu found for "{searchItem}"
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ── Branch ────────────────────────────────────────────── */}
          {/* <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="branch-label">Branch</InputLabel>
            <Select
              labelId="branch-label"
              value={branch}
              label="Branch"
              onChange={handleChange}
            >
              <MenuItem value=""><em>None</em></MenuItem>
              {allBranchData.map((item, index) => (
                <MenuItem key={index} value={item.DEPTNO}>
                  {item.DEPTNO}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          {/* ── User icon ─────────────────────────────────────────── */}
          <div className="flex flex-col items-center mx-6">
            <img src={userIcon} alt="userIcon" className="w-[40px] h-[40px] rounded-full" />
            <p className="text-[0.6rem] font-semibold">{accessGroup}</p>
          
          </div>

          {/* ── Sign out ──────────────────────────────────────────── */}
          <button
            onClick={onSignOut}
            className="flex justify-center items-center bg-red-500 text-white p-1 mr-4 rounded"
          >
            <div className="flex flex-col justify-center items-center text-center">
              <AiOutlineExport className="w-6 h-5" />
              <span className="text-[0.5rem]">Sign Out</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavBar;